export const languageFilter = (language: string) => (x: any) =>
  x.language === language || (language === "en" && !x.language);

export interface Alternate {
  language: string;
  url: string;
  fallback: boolean;
}

export const siteLanguageToMakeCodeLanguage = (
  lang: string | undefined
): string | undefined => {
  return lang;
};
